import { render, staticRenderFns } from "./ModalMenu.vue?vue&type=template&id=487ff464"
import script from "./ModalMenu.vue?vue&type=script&lang=js"
export * from "./ModalMenu.vue?vue&type=script&lang=js"
import style0 from "./ModalMenu.vue?vue&type=style&index=0&id=487ff464&prod&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports